import styled from 'styled-components';
export var CarouselContainer = styled.div.withConfig({
  displayName: "partials__CarouselContainer",
  componentId: "sc-1a8ndxw-0"
})(["width:100%;position:relative;margin-bottom:48px;"]);
export var Carousel = styled.div.withConfig({
  displayName: "partials__Carousel",
  componentId: "sc-1a8ndxw-1"
})(["position:relative;width:100%;overflow:hidden;height:auto;"]);
export var CarouselTrack = styled.div.withConfig({
  displayName: "partials__CarouselTrack",
  componentId: "sc-1a8ndxw-2"
})(["display:flex;transition:transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94);height:100%;"]);
export var CarouselImage = styled.img.withConfig({
  displayName: "partials__CarouselImage",
  componentId: "sc-1a8ndxw-3"
})(["width:100%;height:100% !important;object-fit:cover;transition:transform 0.3s ease;"]);
export var CarouselOverlay = styled.div.withConfig({
  displayName: "partials__CarouselOverlay",
  componentId: "sc-1a8ndxw-4"
})(["position:absolute;bottom:0;left:0;right:0;background:linear-gradient(transparent,rgba(0,0,0,0.7));padding:30px 20px 20px;color:white;transform:translateY(0%);transition:transform 0.3s ease;justify-items:center;h3{font-size:1.5rem;margin-bottom:8px;}p{font-size:0.95rem;opacity:0.9;}"]);
export var CarouselSlide = styled.div.withConfig({
  displayName: "partials__CarouselSlide",
  componentId: "sc-1a8ndxw-5"
})(["min-width:100%;position:relative;overflow:hidden;:hover img{transform:scale(1.05);}:hover ", "{transform:translateY(100%);}"], CarouselOverlay);
export var CarouselBtn = styled.button.withConfig({
  displayName: "partials__CarouselBtn",
  componentId: "sc-1a8ndxw-6"
})(["position:absolute;top:50%;transform:translateY(-50%);background:rgba(76,82,255,0.9);border:none;width:40px;height:40px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:1rem;color:white;transition:all 0.3s ease;z-index:10;box-shadow:0 3px 10px rgba(76,82,255,0.3);&:hover{background:#4c52ff;transform:translateY(-50%) scale(1.1);box-shadow:0 8px 25px rgba(76,82,255,0.4);}&:active{transform:translateY(-50%) scale(0.95);}&.prev{left:20px;}&.next{right:20px;}"]);
export var CarouselIndicators = styled.div.withConfig({
  displayName: "partials__CarouselIndicators",
  componentId: "sc-1a8ndxw-7"
})(["display:flex;justify-content:center;gap:12px;margin-top:25px;box-sizing:border-box;display:flex;align-items:center;"]);
export var Indicator = styled.div.withConfig({
  displayName: "partials__Indicator",
  componentId: "sc-1a8ndxw-8"
})(["width:12px;height:12px;border-radius:100px;background:rgba(76,82,255,0.3);cursor:pointer;transition:all 0.3s ease;border:2px solid transparent;&.active{background:#4c52ff;transform:scale(1.2);box-shadow:0 0 15px rgba(76,82,255,0.5);}&:hover{background:rgba(76,82,255,0.6);}"]);